import React from 'react';
import { scroller } from 'react-scroll';
import { useTranslation } from 'react-i18next';

import ProductHeroLayout from './ProductHeroLayout';
import Typography from '../../components/Typography';
import Button from '../../components/Button';
import DropdownBooking from './DropdownList';

const backgroundImage = '/b2-hero-1600.jpg';

export default function Hero() {
  const { t } = useTranslation();

  const handleOnClickContact = () => {
    scroller.scrollTo('contacts', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -50,
    });
  };
  const handleOnClickApartments = () => {
    scroller.scrollTo('apartments', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -50,
    });
  };
  const handleOnClickPrices = () => {
    scroller.scrollTo('prices', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -50,
    });
  };
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#7fc7d9',
        backgroundPosition: 'center',
      }}
    >
      <img
        style={{ display: 'none' }}
        src={backgroundImage}
        alt="s luxury princess suite"
        loading="eager"
        decoding="async"
        width={1600}
        height={1147}
      />
      <Typography
        color="primary.dark"
        align="center"
        variant="h4"
        marked="center"
        sx={{
          mt: { xs: 2, sm: 7 },
          fontSize: { xs: '1.8rem', sm: '2.125rem' },
          lineHeight: 1.15,
        }}
      >
        {t('productHero.slogan1')}
      </Typography>
      <Typography
        color="secondary.dark"
        align="center"
        variant="h5"
        sx={{
          mb: { xs: 2.5, sm: 5 },
          mt: { xs: 2, sm: 5 },
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
          lineHeight: 1.25,
        }}
      >
        {t('productHero.slogan2')}
      </Typography>
      <DropdownBooking />

      <Button
        color="secondary"
        variant="contained"
        size="large"
        onClick={handleOnClickApartments}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          maxWidth: 320,
          minWidth: { xs: 0, sm: 200 },
          my: { xs: 1, sm: 2 },
        }}
      >
        {t('productHero.button2')}
      </Button>

      <Button
        color="secondary"
        variant="contained"
        size="large"
        onClick={handleOnClickPrices}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          maxWidth: 320,
          minWidth: { xs: 0, sm: 200 },
          mb: { xs: 1, sm: 2 },
        }}
      >
        {t('productHero.button3')}
      </Button>

      <Button
        color="secondary"
        variant="contained"
        size="large"
        onClick={handleOnClickContact}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          maxWidth: 320,
          minWidth: { xs: 0, sm: 200 },
          mb: 0,
        }}
      >
        {t('productHero.button')}
      </Button>

      {/* {isModalOpen && (
        <ContactsModal open={isModalOpen} onClose={closeModal} t={t} />
      )} */}
    </ProductHeroLayout>
  );
}

// function ContactsModal({ open, onClose, t }) {
//   if (!open) return null;

//   const modalStyles = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     zIndex: 9999,
//   };

//   const contentStyles = {
//     backgroundColor: "#fff",
//     padding: "0px",
//     maxWidth: "100%",
//     maxHeight: "100%",
//     overflowY: "auto",
//   };

//   return (
//     <Box style={modalStyles} onClick={onClose}>
//       <Box style={contentStyles}>
//         <Contacts />
//         <Button onClick={onClose} color="primary">
//           {t("apModal.close")}
//         </Button>
//       </Box>
//     </Box>
//   );
// }
